import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-4" }, null, -1);
const _hoisted_2 = {
    key: 0,
    class: "pb-0"
};
const _hoisted_3 = {
    class: "mb-0",
    style: { "font-size": "14px" }
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-4 mb-3" }, null, -1);
const _hoisted_9 = { style: { "font-size": "14px" } };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 2 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormFull = _resolveComponent("FormFull");
    const _component_Section = _resolveComponent("Section");
    const _component_StylesAllMolTypes = _resolveComponent("StylesAllMolTypes");
    return (_openBlock(), _createElementBlock("span", null, [
        (_ctx.numselectedRegions === 1)
            ? (_openBlock(), _createBlock(_component_Section, {
                key: 0,
                title: "Region"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_FormFull, {
                        modelValue: _ctx.constructedRegionForm,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.constructedRegionForm) = $event)),
                        id: "region-style"
                    }, null, 8, ["modelValue"]),
                    _hoisted_1
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createVNode(_component_Section, { title: "Molecules" }, {
            default: _withCtx(() => [
                (_ctx.visibleTreeNodes.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, [
                            (_ctx.treeNodesWithModel.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " The workspace contains no molecules. "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, "No molecules are currently visible."))
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_StylesAllMolTypes)
                    ]))
            ]),
            _: 1
        }),
        (_ctx.numselectedRegions !== 1 || _ctx.treeNodesWithRegions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Section, {
                    title: "Region",
                    class: "pb-2"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_9, [
                            (_ctx.treeNodesWithRegions.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " The workspace contains no regions. "))
                                : (_ctx.numselectedRegions === 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " No region selected (clicked) in the Navigator panel "))
                                    : (_ctx.numselectedRegions > 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Select only one region in the Navigator panel "))
                                        : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                })
            ]))
            : _createCommentVNode("", true)
    ]));
}
